import React, { useEffect, useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
import {
  GetASD,
  GetASDDashPostventas,
  GroupByForeignKey,
  GroupByPropCheck,
  GroupByProps,
} from "../../../Finanzas/Actions/GetContainer";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { EjercicioByRange } from "../../../Finanzas/Helper/EjercicioByRange";
import { PeriodoSelect } from "../../../Ventas/FacturacionMaquinaria/PeriodoSelect";
import { EstatusSelect } from "../Modales/EstatusSelect";
import { MotivosSelect } from "../Modales/MotivosSelect";
import { WhatsAppSelect } from "../Modales/WhatsAppSelect";
import { DropFacturado } from "../Modales/mdlFacturado";
import { HorasUsoSelect } from "../Mantenimiento/HorasUsoSelect";
import { EstadoBasicoSelect } from "../Mantenimiento/EstadoBasicoSelect";
import { MotivosServicioSelect } from "../Mantenimiento/MotivosServicioSelect";

const FiltroPostventaCotizaciones = ({
  onExecute,
  boxState,
  onBoxChange,
  cargarfiltros = true,
  mostrarestatus = false,
  mostrarmotivo = false,
  mostrarwhatsapp = false,
  mostrarfacturado = false,
  dashboard = false,
  mostrarhoras = false,
  mostrarestadobasico = false,
  mostrarmotivoServicios = false,
  ejercicio_inicio,
  ejercicio_fin,
  periodo_inicio,
  periodo_fin,
  sucursalesEncontrados,
  adrEncontrados,
  estatusEncontrado,
  motivoEncontrado,
  filtroSucursales,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [state, setState] = useState({
    linea: 0,
    adr: [],
    sucursal: [],
    whatsapp: "C",
    facturado: "C",
    estatus: estatusEncontrado,
    motivo: motivoEncontrado,
    horasuso: 0,
    ejercicio_inicio: ejercicio_inicio,
    ejercicio_fin: ejercicio_fin,
    periodo: new Date().getMonth() + 1,
    periodo_inicio: periodo_inicio,
    periodo_fin: periodo_fin,
  });
  const { data, adr, sucursal, departamento } = state;

  const onOpenModal = () => {
    const container = document.getElementById("mdlFiltros-modal");
    if (!container) return;
    if (openModal) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };

  const capitalizeWords = (text) => {
    return text
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  useEffect(() => {
    // onClose();
    if (cargarfiltros)
      if (dashboard) {
        // Si dashboard es true, usamos GetASDDashPostventas
        GetASDDashPostventas()
          .then((res) => {
            setState({
              ...state,
              data: res,
            });

            onBoxChange("pv", {
              adr: GroupByProps(res, ["idadr", "adr"]),
              sucursal: filtroSucursales.sucursal,
              departamento: [],
            });
          })
          .catch((err) => console.log(err));
      } else {
        // Si dashboard es false, usamos GetASD
        GetASD()
          .then((res) => {
            setState({
              ...state,
              data: res,
            });

            onBoxChange("pv", {
              adr: GroupByProps(res, ["idadr", "adr"]),
              sucursal: filtroSucursales.sucursal,
              departamento: [],
            });
          })
          .catch((err) => console.log(err));
      }
  }, []);

  useEffect(() => {
    var newadr = GroupByPropCheck(data, ["idadr", "adr"]);
    var newsucursal = GroupByPropCheck(data, ["idsucursal", "sucursal"], false);
    var newdepartamento = GroupByPropCheck(
      data,
      ["iddepartamento", "departamento"],
      false
    );

    let sucursalesSI = false;
    let sucursalesMarcadas = [];
    if (
      sucursalesEncontrados !== null &&
      sucursalesEncontrados !== undefined &&
      sucursalesEncontrados !== ""
    ) {
      sucursalesSI = true;

      const sucursalesSeleccionadas = sucursalesEncontrados
        .split(",")
        .map((idsucursal) => Number(idsucursal));

      sucursalesMarcadas = newsucursal.map((item) => ({
        ...item,
        checked: sucursalesSeleccionadas.includes(Number(item.idsucursal)),
      }));
    }

    let adrSI = false;
    let adrMarcados = [];
    if (
      adrEncontrados !== null &&
      adrEncontrados !== undefined &&
      adrEncontrados !== ""
    ) {
      adrSI = true;

      const adrSeleccionados = adrEncontrados
        .split(",")
        .map((idadr) => Number(idadr));

      adrMarcados = newadr.map((item) => ({
        ...item,
        checked: adrSeleccionados.includes(Number(item.idadr)),
      }));
    }

    setState({
      ...state,
      adr: adrSI === true ? adrMarcados : newadr,
      sucursal: sucursalesSI === true ? sucursalesMarcadas : newsucursal,
      departamento: newdepartamento,
    });
  }, [data]);

  const onCargar = () => {
    if (
      state.ejercicio_inicio === undefined ||
      state.ejercicio_inicio === null ||
      state.ejercicio_inicio === ""
    ) {
      Swal.fire(
        "DASHBOARD",
        "Favor de seleccionar el ejercicio de inicio",
        "warning"
      );
      return;
    }
    if (
      state.ejercicio_fin === undefined ||
      state.ejercicio_fin === null ||
      state.ejercicio_fin === ""
    ) {
      Swal.fire(
        "DASHBOARD",
        "Favor de seleccionar el ejercicio final",
        "warning"
      );
      return;
    }
    if (
      state.ejercicio_inicio > state.ejercicio_fin
    ) {
      Swal.fire(
        "DASHBOARD",
        "El ejercicio de inicio no puede ser mayor al final",
        "warning"
      );
      return;
    }
    if (
      state.periodo_inicio === undefined ||
      state.periodo_inicio === null ||
      state.periodo_inicio === ""
    ) {
      Swal.fire(
        "DASHBOARD",
        "Favor de seleccionar el periodo de inicio",
        "warning"
      );
      return;
    }
    onOpenModal();
    onExecute(
      state.ejercicio_inicio,
      state.ejercicio_fin,
      state.periodo_inicio,
      state.periodo_fin,
      state.facturado,
      state.whatsapp,
      state.estatus,
      state.motivo
    );
    // .then((result) => {
    // })
    // .catch((error) => {
    //     Swal.fire("RESUMEN DE CARTERA MENSUAL", JSON.stringify(error), "error");
    // });
  };

  const labelclick = ({ target }) => {
    target.parentNode.firstChild.click();
  };

  const selectedClick = ({ target }, index) => {
    switch (target.name) {
      case "chk-adr":
        var newarray = adr;
        newarray[index].checked = target.checked;

        var newarrarsucursal = [];
        var newarraydepartamento = [];
        var adrActive = [];
        newarray.forEach((item) => {
          if (item.checked) {
            adrActive = [...adrActive, { idadr: item.idadr, adr: item.adr }];
            newarrarsucursal = newarrarsucursal.concat(
              GroupByForeignKey(data, "idadr", item.idadr, [
                "idsucursal",
                "sucursal",
              ])
            );
            newarraydepartamento = newarraydepartamento.concat(
              GroupByForeignKey(data, "idadr", item.idadr, [
                "iddepartamento",
                "departamento",
              ])
            );
          }
        });
        onBoxChange("pv", {
          adr: adrActive,
          sucursal: [],
          departamento: [],
        });
        setState({
          ...state,
          adr: newarray,
          sucursal:
            newarrarsucursal.length == 0
              ? GroupByPropCheck(data, ["idsucursal", "sucursal"], false)
              : GroupByPropCheck(
                newarrarsucursal,
                ["idsucursal", "sucursal"],
                false
              ),
          departamento:
            newarraydepartamento.length == 0
              ? GroupByPropCheck(
                data,
                ["iddepartamento", "departamento"],
                false
              )
              : GroupByPropCheck(
                newarraydepartamento,
                ["iddepartamento", "departamento"],
                false
              ),
        });
        break;
      case "chk-sucursal":
        var newarray = sucursal;
        newarray[index].checked = target.checked;

        var newarraydepartamento = [];
        var sucursalactiva = [];
        newarray.forEach((item) => {
          if (item.checked) {
            sucursalactiva = [
              ...sucursalactiva,
              { idsucursal: item.idsucursal, sucursal: item.sucursal },
            ];
            newarraydepartamento = newarraydepartamento.concat(
              GroupByForeignKey(data, "idsucursal", item.idsucursal, [
                "iddepartamento",
                "departamento",
              ])
            );
          }
        });
        onBoxChange("pv", {
          adr: boxState.pv.adr,
          sucursal: sucursalactiva,
          departamento: [],
        });
        setState({
          ...state,
          sucursal: newarray,
          departamento:
            newarraydepartamento.length == 0
              ? GroupByPropCheck(
                data,
                ["iddepartamento", "departamento"],
                false
              )
              : GroupByPropCheck(
                newarraydepartamento,
                ["iddepartamento", "departamento"],
                false
              ),
        });
        break;
      default:
        var newarray = departamento;
        var departamentoactivo = [];
        newarray[index].checked = target.checked;

        newarray.forEach((item) => {
          if (item.checked) {
            departamentoactivo = [
              ...departamentoactivo,
              {
                iddepartamento: item.iddepartamento,
                departamento: item.departamento,
              },
            ];
          }
        });
        onBoxChange("pv", {
          adr: boxState.pv.adr,
          sucursal: boxState.pv.sucursal,
          departamento: departamentoactivo,
        });
        setState({
          ...state,
          departamento: newarray,
        });
        break;
    }
  };

  const onChange = ({ target }) => {
    setState({
      ...state,
      [target.name]: target.value,
    });
    onBoxChange(target.name, target.value);
  };

  const onChangeEstatus = ({ target }) => {
    // Actualizamos el estado local igual que en onChange
    setState({
      ...state,
      [target.name]: target.value,
    });

    // Actualizamos boxState
    onBoxChange(target.name, target.value);

    // Si el valor seleccionado NO es "SI", forzamos motivo en boxState a "CC"
    // if (target.value !== "SI") {
    //   setState({
    //     ...state,
    //     motivo: 'CC'
    //   });
    // }
  };


  return (
    <div className="filtros-pedidos-facturados">
      <div className="reporte-buro-credito-filtrado" onClick={onOpenModal}>
        <FilterAltIcon /> Filtrar
      </div>
      <div
        className="mdl-filtro-resumen-cartera mdl-filtro-cotizaciones"
        id="mdlFiltros-modal"
      >
        <PlantillaScreen
          titulo={`Filtro`}
          className_main={1}
          className={
            "modal-filtro-resumen-cartera-mensual mdl-filtro-cotizaciones"
          }
        >
          <div className="filtro-soy-el-titulo-header" onClick={onOpenModal}>
            X
          </div>
          <div className="modal-filtro-resumen-cartera-mensual-container">
            <div className="modal-filtro-resumen-cartera-mensual-container-filtros">
              <div className="filtro-tiempo-tipo">
                <div className="filtro-group">
                  <label>Ejercicio Inicio</label>
                  <EjercicioByRange
                    name="ejercicio_inicio"
                    value={state.ejercicio_inicio}
                    onChange={onChange}
                    extrayear={3}
                  />
                  <label>Periodo Inicio</label>
                  <PeriodoSelect
                    name="periodo_inicio"
                    value={state.periodo_inicio}
                    onChange={onChange}
                  />
                  <label>Ejercicio Fin</label>
                  <EjercicioByRange
                    name="ejercicio_fin"
                    value={state.ejercicio_fin}
                    onChange={onChange}
                    extrayear={3}
                  />
                  <label>Periodo Fin</label>
                  <PeriodoSelect
                    name="periodo_fin"
                    value={state.periodo_fin}
                    onChange={onChange}
                  />
                  {/* <>
                    <label>Facturados</label>
                    <DropFacturado
                      name="facturado"
                      value={state.facturado}
                      onChange={onChange}
                    />
                  </> */}
                  {/* {mostrarwhatsapp && (
                    <>
                      <label>Contacto registrado</label>
                      <WhatsAppSelect
                        name="whatsapp"
                        value={state.whatsapp}
                        onChange={onChange}
                      />
                    </>
                  )} */}
                  {mostrarhoras && (
                    <>
                      <label>Hrs Estimadas de Uso</label>
                      <HorasUsoSelect
                        name="horasuso"
                        value={state.horasuso}
                        onChange={onChange}
                      />
                    </>
                  )}
                  {mostrarestadobasico && (
                    <>
                      <label>Estado</label>
                      <EstadoBasicoSelect
                        name="estatus"
                        value={state.estatus}
                        onChange={onChangeEstatus}
                      />
                    </>
                  )}
                  {mostrarestatus && (
                    <>
                      <label>Estado</label>
                      <EstatusSelect
                        name="estatus"
                        value={state.estatus}
                        onChange={onChangeEstatus}
                      />
                    </>
                  )}
                  {state.estatus === "SI" && mostrarmotivoServicios && (
                    <>
                      <label>Motivo</label>
                      <MotivosServicioSelect
                        name="motivo"
                        value={state.motivo}
                        onChange={onChange}
                      />
                    </>
                  )}
                  {state.estatus === "SI" && mostrarmotivo && (
                    <>
                      <label>Motivo</label>
                      <MotivosSelect
                        name="motivo"
                        value={state.motivo}
                        onChange={onChange}
                      />
                    </>
                  )}
                </div>
                <div
                  className="mdlFiltros-modal-acciones-guardar"
                  onClick={onCargar}
                >
                  Cargar
                </div>
              </div>
              <div className="filtro-adr">
                <div className="title title-adr">REGION</div>
                {adr.map((item, index) => (
                  <div key={`${item}-${index}`} className="chk-groups">
                    <input
                      type="checkbox"
                      name="chk-adr"
                      onChange={(e) => selectedClick(e, index)}
                      checked={item.checked}
                      value={item.idadr}
                    />
                    <label>{item.adr}</label>
                  </div>
                ))}
              </div>
              <div className="filtro-sucursal">
                <div className="title-sucursal">SUCURSAL</div>
                {sucursal.map((item, index) => (
                  <div key={`${item}-${index}`} className="chk-groups">
                    <input
                      type="checkbox"
                      name="chk-sucursal"
                      className="my-checkbox"
                      onChange={(e) => selectedClick(e, index)}
                      checked={item.checked}
                      value={item.idsucursal}
                    />
                    <label onClick={labelclick}>
                      {capitalizeWords(item.sucursal)}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <div className="mdlFiltros-modal-acciones"></div>
          </div>
        </PlantillaScreen>
      </div>
    </div>
  );
};

export default FiltroPostventaCotizaciones;
